<template>
  <div class="box">
    <div class="search">
        <el-input placeholder="请输入菜单名称" class="width" v-model="Switch.name" clearable></el-input>
        <el-button type="primary" class="left" @click="list">查询</el-button>
        <el-button type="primary" @click="$router.push({ name: 'pageadd' })" class="left">新增</el-button>
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        v-loading="loading"
        border>
        <el-table-column prop="id" label="序号" width="80"></el-table-column>
        <el-table-column prop="mName" label="菜单名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="mUrl" label="菜单路由" show-overflow-tooltip></el-table-column>
        <el-table-column prop="title" label="页面标题" show-overflow-tooltip></el-table-column>
        <el-table-column prop="views" label="浏览量" show-overflow-tooltip></el-table-column>
        <el-table-column prop="sort" label="排序" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" show-overflow-tooltip>
            <template slot-scope="scope">
                <el-button size="mini" @click="handleEdit(scope.row.id)">编辑</el-button>
                <el-button class="left" size="mini" type="danger" @click="del(scope.row.id)">删除</el-button>
            </template>
        </el-table-column>
      </el-table>
      <div class="fy">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          background
          layout="prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Switch: {
        name: ''
      },
      loading: false,
      tableData: [],
      currentPage: 1,
      total: 0
    }
  },
  created() {
    this.list()
  },
  methods: {
    // 列表数据
    async list() {
      this.loading = true
      let res = await this.$http.post('/pageData/list', {
        mName: this.Switch.name ? this.Switch.name : null,
        current: this.currentPage,
        size: 10
      })
      this.loading = false
      if(res.data.code == 200) {
        this.tableData = res.data.data
        this.total = res.data.count
      }
    },
    async del(id) {
        this.$confirm('是否删除此条数据？', '提醒', {
            distinguishCancelAndClose: true,
            confirmButtonText: '确认',
            cancelButtonText: '取消'
        }).then(async () => {
            let res = await this.$http.post('/pageData/delete', {
                ids: id
            })
            if(res.data.code == 200) {
                this.$message({
                    type: 'success',
                    message: '删除成功',
                    center: true,
                    offset: 50
                })
                this.list()
            }
        })
        .catch(action => {
            return false;
        })
    },
    async handleEdit(id) {
        this.$router.push({ name: 'pageadd', query: { id: id } })
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
      this.list()
    }
  }
}
</script>

<style lang="less" scoped>
.box{
  padding: 10px;
  background-color: #fff;
}
.width {
    width: 250px !important;
}
</style>